var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilentNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49951 12.8334C5.9362 13.9986 7.11448 14.8334 8.49951 14.8334C9.88454 14.8334 11.0628 13.9986 11.4995 12.8334",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9764 12.3597C14.9985 11.6683 15.3309 10.2099 14.6198 9.1028L13.8815 7.95338C13.6326 7.5659 13.4987 7.10877 13.4987 6.63971V6.16998C13.4987 3.33237 11.2778 1 8.4993 1C7.5028 1 6.57801 1.30001 5.80168 1.81575L6.41722 2.60969C7.02553 2.22238 7.73936 2 8.4993 2C10.6907 2 12.4987 3.84927 12.4987 6.16998V6.63971C12.4987 7.29811 12.6864 7.9432 13.0401 8.49382L13.7784 9.64324C14.2135 10.3206 13.9732 11.1907 13.3603 11.5651L13.9764 12.3597ZM5.03268 4.08801C4.69421 4.69896 4.49988 5.40913 4.49988 6.16998V6.63971C4.49988 7.29811 4.3122 7.9432 3.95852 8.49382L3.22023 9.64324C2.7177 10.4256 3.11607 11.4651 3.94906 11.7008C6.33349 12.3758 8.82223 12.5105 11.2483 12.1051L11.9386 12.9954C9.20237 13.538 6.37617 13.4272 3.67669 12.663C2.16392 12.2348 1.53267 10.4202 2.37885 9.1028L3.11714 7.95338C3.36603 7.5659 3.49988 7.10877 3.49988 6.63971V6.16998C3.49988 5.08702 3.82337 4.07765 4.37788 3.24343L5.03268 4.08801Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49951 1.35242L13.785 14.4371",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilentNotification);
export default __webpack_public_path__ + "static/media/silentNotification.ef401cd871d81817d5c091b57a67ae72.svg";
export { ForwardRef as ReactComponent };